

jQuery(document).ready(function($) {
  $('.strategy-nav .strategy-nav-item a').on('click', function(e) {
    e.preventDefault();
    $(this).parent().siblings().children('a').removeClass('active');
    $(this).addClass('active');
    $('.strategy-container').hide();
    $('div[id=' + $(this).attr('data-strategy') + ']').show();

  });

  $('span.toggle-info').on('click', function() {
    $('body').addClass('lock');
    $('div[id=' + $(this).attr('data-person') + ']').show();
  });

  $('.additional-info-wrapper .additional-info img.close-popup').on('click', function() {

    $('body').removeClass('lock');
    $(this).parents('.modal').hide();

  });
  
});

